import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  backgroundColor: "#dee3e6",
  flexGrow: 1,
  padding: "20px 0 20px",
}));

export const Block = styled("div")(({ theme }) => ({
  ...theme.mixins.flexJustifyBetween,
  alignItems: "flex-start",
  gap: 20,
  padding: "10px 0",

  [theme.down("lg")]: {
    flexDirection: "column",
  },
}));

export const LoadingBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  width: "100%",
  minHeight: 500,
  backgroundColor: "#dee3e6",
}));

export const ErrorBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  flexDirection: "column",
  width: "100%",
  minHeight: 500,
  backgroundColor: "#dee3e6",
}));

export const SessionBlock = styled("div")(({ theme }) => ({
  fontSize: 12,
  color: "#777",
  marginTop: 5,
}));

export const ModalBlock = styled("div")(({ theme }) => ({
  width: "100%",
  maxWidth: 500,
  height: "auto",
  padding: 20,

  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  gap: 20,

  "&>button": {
    width: "100%",
    maxWidth: 200,
    padding: "10px 20px",
    color: "#fff",

    border: "none",
    borderRadius: 5,

    backgroundColor: theme.palette.searchButtonBg,
    cursor: "pointer",
    fontSize: 16,
    transition: "background-color 0.3s ease",

    "&:hover": {
      backgroundColor: theme.palette.hoverButtonBg,
    },
  },
}));
